export const DEBOUNCE_TIME = 1000;

export const TIME_MODIFIER_VARIANTS = {
  rounded: 'Rounded',
  square: 'Square'
};

export const VARIANTS = {
  Square: {
    containerProps: {
      spacing: 1,
      direction: 'row',
      justifyContent: 'center',
      alignItems: 'center'
    },
    showIcon: true,
    fields: [
      {
        name: 'deliveryWaitTime',
        label: 'TimeModifier:delivery',
        labelVariant: 'body2',
        labelColor: '',
        classNames: {
          container: 'containerDelivery',
          input: 'inputDelivery'
        },
        props: {
          min: 1,
          max: 180,
          readOnly: true
        }
      },
      {
        name: 'pickUpWaitTime',
        label: 'TimeModifier:pickup',
        labelVariant: 'body2',
        labelColor: '',
        classNames: {
          container: 'containerPickup',
          input: 'inputPickup'
        },
        props: {
          min: 1,
          max: 180,
          readOnly: true
        }
      }
    ]
  },
  Rounded: {
    containerProps: {
      spacing: 2,
      direction: 'column'
    },
    fields: [
      {
        name: 'deliveryWaitTime',
        label: 'TimeModifier:deliveryCapitalize',
        labelVariant: 'body1',
        labelColor: 'text.secondary',
        classNames: {
          container: 'containerDeliveryRounded',
          input: 'inputDeliveryRounded'
        },
        props: {
          min: 1,
          max: 180,
          readOnly: true,
          label: 'SettingsSidebar:minutes'
        }
      },
      {
        name: 'pickUpWaitTime',
        label: 'TimeModifier:pickupCapitalize',
        labelVariant: 'body1',
        labelColor: 'text.secondary',
        classNames: {
          container: 'containerPickupRounded',
          input: 'inputPickupRounded'
        },
        props: {
          min: 1,
          max: 180,
          readOnly: true,
          label: 'SettingsSidebar:minutes'
        }
      }
    ]
  }
};
